import { render, staticRenderFns } from "./LicensePlanDescription.vue?vue&type=template&id=439b7940&scoped=true"
import script from "./LicensePlanDescription.vue?vue&type=script&lang=js"
export * from "./LicensePlanDescription.vue?vue&type=script&lang=js"
import style0 from "./LicensePlanDescription.vue?vue&type=style&index=0&id=439b7940&prod&lang=css"
import style1 from "./LicensePlanDescription.vue?vue&type=style&index=1&id=439b7940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439b7940",
  null
  
)

export default component.exports